import * as THREE from 'three';
import { refs } from './refs';
import { renderer } from './scene';
import { buildBook } from './book';

// ─── Texture loader ────────────────────────────────────────────────
export const loader = new THREE.TextureLoader();

export function loadImageAsTexture(src: string): void {
  loader.load(src, tex => {
    if (refs.coverTex) refs.coverTex.dispose();
    refs.coverTex = tex;
    refs.coverTex.encoding = THREE.sRGBEncoding;
    refs.coverTex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    buildBook();
  });
}
